import * as React from 'react';
const SCAOrders = ({ fillPath, ...restProps }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...restProps}>
    <mask
      id="a"
      width={28}
      height={28}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill={fillPath || '#003594'}
        d="m15.499 19.57-3.904-3.905 1.054-1.053 2.85 2.85 5.67-5.67 1.053 1.054-6.723 6.723Zm5-9.57h-1.5V5.308a.294.294 0 0 0-.096-.212A.294.294 0 0 0 18.69 5H16.5v2.615h-9V5H5.307a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.293.293 0 0 0 .212.096h5.692v1.5H5.307c-.499 0-.925-.177-1.278-.53a1.742 1.742 0 0 1-.53-1.278V5.308c0-.499.177-.925.53-1.278.353-.353.78-.53 1.278-.53h4.406c.138-.487.421-.891.849-1.212.427-.32.906-.48 1.437-.48.551 0 1.038.16 1.46.48.423.321.704.725.842 1.212h4.39c.499 0 .925.177 1.278.53.353.353.53.78.53 1.278V10Zm-8.5-4.885a.876.876 0 0 0 .645-.258.876.876 0 0 0 .259-.646.876.876 0 0 0-.259-.645.876.876 0 0 0-.645-.258.876.876 0 0 0-.645.258.876.876 0 0 0-.259.645c0 .258.086.473.259.646a.876.876 0 0 0 .645.258Z"
      />
    </g>
  </svg>
);
export default SCAOrders;
